const List = () => import(
    /* webpackChunkName: "AggregationSeriesList" */
    '@/modules/aggregationSeries/views/List.vue'
);
const ManageData = () => import(
    /* webpackChunkName: "AggregationSeriesManageData" */
    '@/modules/aggregationSeries/views/ManageData.vue'
);
const View = () => import(
    /* webpackChunkName: "CommodityIdentificationView" */
    '@/modules/commodityIdentifications/views/View.vue'
    );

export default [
    {
        path: '/aggregation-series',
        name: "aggregation_series",
        component: List,
        meta: {
            in_menu: true,
            public: false,
            icon: 'fa-solid fa-boxes-stacked',
            requiresAuth: true
        }
    },
    {
        path: '/aggregation-series/create',
        name: "aggregation_series_create",
        component: ManageData,
        meta: {
            public: false,
            requiresAuth: true
        }
    },
    {
        path: '/aggregation-series/view/:commodity_identification_id',
        name: "aggregation_series_view",
        component: View,
        meta: {
            public: false,
            requiresAuth: true,
            title: 'aggregation_series.views.view.title',
            backTo: 'aggregation_series'
        }
    },
    {
        path: '/aggregation-series/edit/:commodity_identification_id',
        name: "aggregation_series_edit",
        component: ManageData,
        meta: {
            public: false,
            requiresAuth: true
        }
    }
]

